<div class="popup">
  <div class="popup-header">
    <div class="popup-header__top">
      <ng-content select=".header"></ng-content>
      <button (click)="close()" class="close-btn">
        <img src="assets/icons/cross.svg" alt="" />
      </button>
    </div>
  </div>

  <div class="projected-content" [class.remove-padding]="removeInlinePadding()">
    <ng-content select=".main"></ng-content>
    <ng-content select=".footer"></ng-content>
  </div>
</div>

<div class="popup-overlay"></div>
